import $ from 'jquery';
import { Functions } from '../helpers';

export class Equalizer {

	constructor( App ) {
		Equalizer.App         = App;
		Equalizer.UI          = App.PwnUI;
		Equalizer.settings    = App.settings;
        this.$element         = $( '.js-pwn-mh' );
        this.$elementArticle  = $( '.js-mh-article' );
        this.$wrapper         = $( '.js-pwn-site' );
		this.initialize();
	};

	initialize() {
        if ( ! this.$element.length && ! this.$wrapper.length ) return;

        this.$element.matchHeight( {
            byRow: false,
            property: 'height'
        } );

        this.$elementArticle.matchHeight( {
            byRow: false,
            property: 'height'
        } );

        this.$wrapper.imagesLoaded( () => {
            this.$element.matchHeight( {
                byRow: false,
                property: 'height'
            } );

            this.$elementArticle.matchHeight( {
                byRow: false,
                property: 'height'
            } );
        } );
	};
}
